import { _post, _get, _delete } from "./Axios";

export default class KpiCompetenciesApi {
  static get(id = null) {
    if (id == null) {
      return _get("kpi/competencies");
    } else {
      return _get("kpi/competencies/" + id);
    }
  }
  static getbyparam(parameters) {
    let params = [];
    Object.keys(parameters).forEach((element) => {
      params.push(element + "=" + parameters[element]);
    });
    params = params.join("&");
    return _get("kpi/competencies?" + params);
  }
  static post(data) {
    return _post("kpi/competencies", data);
  }
  static update(id, data) {
    return _post("kpi/competencies/" + id, data);
  }
  static delete(id) {
    return _delete("kpi/competencies/" + id);
  }
}
